// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__f6PX3","logo":"sidebar_logo__XwTxw"};